export const Box = () => {
  const features = [
    { text: "Personalised Feed" },
    { text: "Zero Ads" },
    { text: "Instant Alerts" },
    { text: "Local Deals" }

  ];

  return (
    <div>
      <div className="hidden lg:block px-6">
        <section className="w-full flex justify-center bg-[#fafafa]">

          {/* MAIN CARD */}
          <div className="
        relative
        w-full
        max-w-[1700px]
        rounded-[40px]
        bg-white
        shadow-[0px_0px_35px_rgba(0,0,0,0.08)]
        px-[80px]
        py-[80px]
        flex
        items-center
        justify-between
        gap-12
        overflow-visible
      ">

            {/* LEFT SIDE */}
            <div className="max-w-[720px]">

              {/* label */}
              <div className="flex items-center gap-3 mb-6">

                <div className="w-[10px] h-[10px] rounded-full bg-gradient-to-r from-red-600 to-red-900" />

                <span className="text-[18px] text-gray-700">
                  Personalised for You
                </span>

              </div>


              {/* heading */}
              <h2 className="text-[40px] leading-[1.15] font-normal text-neutral-900 mb-6">

                Follow Businesses You Love and
                <br />
                <span className="font-bold">Discover Deals That Matter.</span>

              </h2>


              {/* paragraph */}
              <p className="text-gray-600 text-lg leading-[30px] mb-10">

                Connect with the local businesses you love by following them directly in the app. Their latest offers will build your personalized feed, giving you instant access to the Deals That Matter, without annoying ads or distractions
              </p>


              {/* FEATURES */}
              <div className="grid grid-cols-2 gap-y-6 mb-10">

                {features.map((feature, i) => (

                  <div key={i} className="flex items-center gap-3">

                    <div className="
                  w-[22px]
                  h-[22px]
                  rounded-full
                  bg-gradient-to-r
                  from-red-600
                  to-red-900
                  flex
                  items-center
                  justify-center
                ">

                      <img
                        src="/images/vector-7.svg"
                        className="w-[12px]"
                      />

                    </div>

                    <span className="text-[20px] text-neutral-900">
                      {feature.text}
                    </span>

                  </div>

                ))}

              </div>


              {/* STORE BUTTONS */}
              <div className="flex gap-4">

                {/* APP STORE */}
                <a
                  href="https://couponbook.app.link/BsnZ5PEfH2b"
                  target="_blank"
                  className="flex items-center justify-center h-14 px-6 bg-black rounded-full" rel="noreferrer"
                >
                  <img
                    src="/images/AppleLogo.png"
                    className="w-[150px]"
                  />
                </a>



                {/* GOOGLE PLAY */}
                <a
                  href="https://couponbook.app.link/BsnZ5PEfH2b"
                  target="_blank"
                  className="flex items-center justify-center h-14 px-6 bg-black rounded-full" rel="noreferrer"
                >
                  <img
                    src="/images/rectangle-34625679.png"
                    className="w-[150px]"
                  />
                </a>

              </div>

            </div>


            {/* RIGHT SIDE PHONE */}
            <div className="relative flex justify-center items-center" style={{ width: "clamp(880px, 45vw, 850px)" }}>

              {/* PHONE */}
              <img
                src="/images/Webp/Mobile1.webp"
                className="relative z-10"
                style={{ width: "clamp(250px, 25vw, 360px)" }}
              />

              {/* NEW DEAL ALERT CARD */}
              <div
                className="absolute transbox overflow-hidden border-4 border-solid border-white animate-floatSlow z-30"
                style={{
                  top: "clamp(30px, 6vw, 90px)",
                  right: "clamp(-60px, -8vw, -120px)",
                  width: "clamp(140px, 18vw, 300px)",
                  borderRadius: "clamp(16px, 2vw, 30px)",
                  boxShadow: "0px 40px 80px rgba(0,0,0,0.25)",
                }}
              >
                {/* TOP RED SECTION */}
                <div
                  className="relative bgimg bg-cover bg-center text-white"
                  style={{
                    padding: "clamp(10px, 1.5vw, 24px)",
                    margin: "4px",
                    borderRadius: "clamp(14px, 1.8vw, 28px)",
                  }}
                >
                  <div className="absolute inset-0" />
                  <div
                    className="relative z-10 font-semibold mb-1"
                    style={{ fontSize: "clamp(11px, 1.2vw, 20px)" }}
                  >
                    New deal alert
                  </div>
                  <div
                    className="relative z-10 opacity-90 leading-relaxed font-normal"
                    style={{ fontSize: "clamp(9px, 0.9vw, 14px)" }}
                  >
                    A local spot you follow just dropped a brand new offer. Tap to check it out!
                  </div>
                </div>

                {/* BOTTOM WHITE SECTION */}
                <div style={{ padding: "clamp(8px, 1vw, 20px) clamp(10px, 1.5vw, 24px)" }}>
                  <div
                    className="font-semibold text-black"
                    style={{ fontSize: "clamp(10px, 1.1vw, 18px)" }}
                  >
                    +120 Points Added
                  </div>
                </div>
              </div>

              {/* NOW FOLLOWING CARD */}
              <div
                className="absolute flex items-center transbox backdrop-blur-xl border-solid border-white animate-floatSlowReverse z-20"
                style={{
                  bottom: "clamp(20px, 4vw, 60px)",
                  left: "clamp(-60px, -10vw, -180px)",
                  gap: "clamp(8px, 1vw, 16px)",
                  padding: "clamp(8px, 1vw, 16px) clamp(10px, 1.5vw, 20px)",
                  borderRadius: "clamp(12px, 1.8vw, 26px)",
                  borderWidth: "clamp(2px, 0.3vw, 4px)",
                  boxShadow: "0px 40px 80px rgba(0,0,0,0.18)",
                }}
              >
                {/* PROFILE IMAGE */}
                <img
                  src="/images/Webp/rectangle-34625668.webp"
                  className="object-cover border-2 border-white flex-shrink-0"
                  style={{
                    width: "clamp(32px, 4vw, 64px)",
                    height: "clamp(32px, 4vw, 64px)",
                    borderRadius: "clamp(8px, 1vw, 15px)",
                  }}
                />

                {/* TEXT */}
                <div>
                  <div
                    className="font-semibold text-black"
                    style={{ fontSize: "clamp(10px, 1.1vw, 18px)" }}
                  >
                    Now Following!
                  </div>
                  <div
                    className="font-normal text-gray-600"
                    style={{
                      fontSize: "clamp(8px, 0.85vw, 14px)",
                      maxWidth: "clamp(80px, 12vw, 220px)",
                    }}
                  >
                    You'll now see their latest deals right in your personalized feed.
                  </div>
                </div>
              </div>

            </div>


          </div>



          {/* ANIMATIONS */}
          <style>{`

   

            div.transbox {
              background-color: rgba(255, 231, 231, 0.4);
              -webkit-backdrop-filter: blur(5px);
              backdrop-filter: blur(5px);
              
              font-weight: bold;
            }


                    .bgimg {
                background-image: url('/images/Webp/PersonalisedforYouRedCardBG.webp');
                background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }
        @keyframes floatSlow {
          0%,100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-16px);
          }
        }

        @keyframes floatSlowReverse {
          0%,100% {
            transform: translateY(-10px);
          }
          50% {
            transform: translateY(10px);
          }
        }

        .animate-floatSlow {
          animation: floatSlow 6s ease-in-out infinite;
        }
          .animate-floatSlowDelay {
          animation: floatSlow 5s ease-in-out infinite;
        }

        .animate-floatSlowReverse {
          animation: floatSlowReverse 7s ease-in-out infinite;
        }

      `}</style>


        </section>
      </div>

      <div className="block lg:hidden">
        <section className="w-full flex  bg-[#fafafa]">

          {/* MAIN CARD */}
          <div className="
                relative
                w-full
                max-w-[1700px]
                h-[850px]
                bg-white
                shadow-[0px_0px_35px_rgba(0,0,0,0.08)]
                flex-col
                py-[80px]
                flex
                items-center
                
                
                overflow-visible
              ">

            {/* LEFT SIDE */}
            <div className="max-w-[720px] px-4">

              {/* label */}
              <div className="flex items-center justify-center gap-3 mb-6 ">

                <div className="w-[10px] h-[10px] rounded-full bg-gradient-to-r from-red-600 to-red-900" />

                <span className="text-[18px] text-gray-700">
                  Personalised for You
                </span>

              </div>


              {/* heading */}
              <h2 className="text-[20px] px-6 text-center leading-[1.15] font-semibold text-neutral-900 mb-6">

                Follow Businesses You Love and Discover Deals That Matter.

              </h2>


              {/* paragraph */}
              <p className="text-gray-600 text-[12px] text-center px-6 mb-10 ">

                Connect with the local businesses you love by following them directly in the app. Their latest offers will build your personalized feed, giving you instant access to the Deals That Matter, without annoying ads or distractions
              </p>


              {/* FEATURES */}
              {/* <div className="bg-[#F9F0F0] p-4 flex items-center justify-center mb-10 ">
              <div className="grid grid-cols-2 items-center justify-center gap-y-6 
                    w-full
                    rounded-[24px]">

                {features.map((feature, i) => (

                  <div key={i} className="flex items-center gap-3 w-[150px]
                          h-[18px]">

                    <div className="
                          w-[18px]
                          h-[18px]
                          rounded-full
                          bg-gradient-to-r
                          from-red-600
                          to-red-900
                          flex
                          items-center
                          justify-center
                        ">

                      <img
                        src="/images/vector-7.svg"
                        className="w-[10px]"
                      />

                    </div>

                    <span className="text-[14px] text-neutral-900">
                      {feature.text}
                    </span>

                  </div>

                ))}

              </div>
                    </div> */}




            </div>


            {/* RIGHT SIDE PHONE */}
            <div className="relative flex justify-center items-center w-[360px]">

              {/* PHONE */}
              <img
                src="/images/Webp/Mobile1.webp"
                className="w-[220px] relative z-10"
              />


              <div
                className="
                absolute
                top-[30px]
                right-[-25px]
                w-[200px]
                rounded-[20px]
                overflow-hidden
                transbox
                border-6 border-solid border-white
                shadow-[0px_40px_80px_rgba(0,0,0,0.25)]
                animate-floatSlow
                z-30 mr-9
              "
              >

                {/* TOP RED IMAGE SECTION */}
                <div
                  className="
                  relative
                  bgimg
                  rounded-[20px]
                  bg-cover
                  m-1
                  bg-center
                  text-white
                  p-4
                "
                >

                  {/* optional overlay for readability */}
                  <div className="absolute inset-0 " />

                  <div className="relative z-10 text-[12px] font-semibold mb-2">
                    New deal alert
                  </div>

                  <div className="font-normal relative z-10 text-[8px] opacity-90 leading-relaxed">
                    A local spot you follow just dropped a brand new offer. Tap to check it out!
                  </div>

                </div>

                {/* BOTTOM WHITE SECTION */}
                <div className="px-4 py-2">
                  <div className="text-[12px] font-semibold text-black">
                    +120 Points Added
                  </div>
                </div>

              </div>



              {/* VERIFIED DEAL CARD */}
              <div
                className="
                absolute
                bottom-[20px]
                left-[10px]
                flex
                items-center
                gap-4
                px-5
                py-4
                rounded-[26px]
                transbox
                backdrop-blur-xl
                border-4 border-solid border-white
                shadow-[0px_40px_80px_rgba(0,0,0,0.18)]
                animate-floatSlowReverse
                z-20 border
              "
              >

                {/* PROFILE IMAGE */}
                <img
                  src="/images/Webp/rectangle-34625668.webp"
                  className="
                  w-[40px]
                  h-[40px]
                  rounded-[5px]
                  object-cover
                  border-2 border-white
                "
                />


                {/* TEXT */}
                <div>

                  <div className="font-semibold text-[12px] text-black">
                    Now Following!
                  </div>

                  <div className="font-normal text-[8px] text-gray-600 max-w-[90px]">
                    You'll now see their latest deals right in your personalized feed.
                  </div>

                </div>

              </div>



              {/* FADE */}
              {/* <div className="
                absolute
                bottom-0
                w-[650px]
                h-[220px]
                bg-gradient-to-t
                from-white
                to-transparent
                z-30
                pointer-events-none
              "/> */}
              <div className="absolute px-4 justify-center bottom-[-245px] z-30">
                <div className="flex justify-center bg-[#F9F0F0] rounded-[24px] px-8 py-6 w-fit mb-4">

                  <div className="grid grid-cols-2 gap-x-6 gap-y-5">

                    {/* ITEM */}
                    {[
                      "Personalised Feed",
                      "Zero Ads",
                      "Instant Alerts",
                      "Local Deals",
                    ].map((feature, i) => (
                      <div key={i} className="flex items-center gap-2">

                        {/* RED CHECK ICON */}
                        <div className="
          w-4 h-4
          rounded-full
          bg-red-600
          flex items-center justify-center
        ">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-3 h-3 text-white"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.704 5.29a1 1 0 010 1.42l-7.25 7.25a1 1 0 01-1.42 0l-3.25-3.25a1 1 0 111.42-1.42l2.54 2.54 6.54-6.54a1 1 0 011.42 0z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>

                        {/* TEXT */}
                        <span className="text-[12px] text-gray-800 w-fit">
                          {feature}
                        </span>

                      </div>
                    ))}

                  </div>

                </div>
                {/* STORE BUTTONS */}
                <div className="flex flex-col gap-3 w-full">

                  {/* APP STORE */}
                  <a
                    href="https://couponbook.app.link/BsnZ5PEfH2b"
                    target="_blank"
                    className="flex items-center justify-center h-[52px] w-full bg-black rounded-full" rel="noreferrer"
                  >
                    <img
                      src="/images/AppleLogo.png"
                      className="w-[130px]"
                    />
                  </a>

                  {/* GOOGLE PLAY */}
                  <a
                    href="https://couponbook.app.link/BsnZ5PEfH2b"
                    target="_blank"
                    className="flex items-center justify-center h-[52px] w-full bg-black rounded-full" rel="noreferrer"
                  >
                    <img
                      src="/images/rectangle-34625679.png"
                      className="w-[130px]"
                    />
                  </a>

                </div>
              </div>


            </div>


          </div>



          {/* ANIMATIONS */}
          <style>{`

   

div.transbox {
  background-color: rgba(255, 231, 231, 0.4);
  -webkit-backdrop-filter: blur(7px);
  backdrop-filter: blur(7px);
  
  font-weight: bold;
}


        .bgimg {
    background-image: url('/images/Webp/PersonalisedforYouRedCardBG.webp');
    background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
        @keyframes floatSlow {
          0%,100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-16px);
          }
        }

        @keyframes floatSlowReverse {
          0%,100% {
            transform: translateY(-10px);
          }
          50% {
            transform: translateY(10px);
          }
        }

        .animate-floatSlow {
          animation: floatSlow 6s ease-in-out infinite;
        }
          .animate-floatSlowDelay {
          animation: floatSlow 5s ease-in-out infinite;
        }

        .animate-floatSlowReverse {
          animation: floatSlowReverse 7s ease-in-out infinite;
        }

      `}</style>


        </section>
      </div>
    </div>


  );
};